import React, { Suspense, lazy } from 'react';

const LazyApp = lazy(() => import('./AppEntry'));

const fallbackStyles: React.CSSProperties = {
  height: '100vh',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden'
};

const fallbackIndicatorStyles: React.CSSProperties = {
  width: '40px',
  height: '40px',
  border: '3px solid rgba(0, 0, 0, 0.08)',
  borderTopColor: 'rgba(0, 0, 0, 0.26)',
  borderRadius: '50%',
  animation: 'boot-loading-spin 900ms linear infinite',
};

const fallbackStylesheet = `
@keyframes boot-loading-spin {
  to { transform: rotate(360deg); }
}`;

const BootFallback = () => {
  return (
    <div style={fallbackStyles} aria-busy="true" aria-live="polite">
      <style>{fallbackStylesheet}</style>
      <div style={fallbackIndicatorStyles} />
    </div>
  );
};

const Boot = () => {
  return (
    <Suspense fallback={<BootFallback />}>
      <LazyApp />
    </Suspense>
  );
};

export default Boot;
